import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import toast from 'react-hot-toast';
import { getErrorString } from '../../utils';
import { fetchGmailEmails, getThreadApi, modifyMessagesApi } from '../../api/gmail-api';

const initialState = {
  emails: {},
  marked: [],
  thread: {},
  readLoading: false,
  loading: false,
};

export const fetchEmailListing = createAsyncThunk('email/listing', async (paramsObj = {}) => {
  try {
    const res = await fetchGmailEmails('', { ...paramsObj, limit: 10 });
    return res;
  } catch (error) {
    toast.error(getErrorString(error));
  }
});

export const fetchEmailThread = createAsyncThunk('email/thread', async (paramsObj = {}) => {
  try {
    const res = await getThreadApi('', paramsObj);
    return res;
  } catch (error) {
    toast.error(getErrorString(error));
  }
});

export const modifyEmails = createAsyncThunk('modify/emails', async (data = {}) => {
  try {
    const res = await modifyMessagesApi(data);
    return res;
  } catch (error) {
    toast.error(getErrorString(error));
  }
});

const GmailSlice = createSlice({
  name: 'gmail',
  initialState,
  reducers: {
    setMarkedMessages: (state, action) => {
      state.marked = action?.payload;
    },
    setEmailThread: (state, action) => {
      state.thread = action?.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchEmailListing.pending, (state, action) => {
        if (!action.meta?.arg?.page_token) state.emails = {};
        state.loading = true;
      })
      .addCase(fetchEmailListing.fulfilled, (state, action) => {
        if (action.meta?.arg?.page_token) {
          state.emails.next_page_token = action?.payload?.data?.next_page_token;
          state.emails.threads = [...(state.emails?.threads || []), ...(action?.payload?.data?.threads || [])];
        } else {
          state.emails = action?.payload?.data || {};
        }
        state.loading = false;
      })
      .addCase(fetchEmailListing.rejected, (state) => {
        state.loading = false;
      })
      .addCase(modifyEmails.pending, (state) => {
        state.readLoading = true;
      })
      .addCase(modifyEmails.fulfilled, (state, action) => {
        state.marked = [];
        const messageIds = action.meta?.arg?.message_ids?.split(',');
        state.emails.threads = state?.emails?.threads?.map((thread) => ({
          ...thread,
          messages: thread?.messages?.map((message) =>
            messageIds?.includes(message?.id) ? { ...message, unread: action.meta?.arg?.unread } : message,
          ),
        }));
        state.readLoading = false;
      })
      .addCase(modifyEmails.rejected, (state) => {
        state.readLoading = false;
      })
      .addCase(fetchEmailThread.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchEmailThread.fulfilled, (state, action) => {
        state.thread = action?.payload?.data;
        state.loading = false;
      })
      .addCase(fetchEmailThread.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setMarkedMessages, setEmailThread } = GmailSlice.actions;
export default GmailSlice.reducer;
